import { ReactivateModal } from '@presentation/components/templates'

type Props = {
  id: string
  onReactivate: () => void
}

const ReactivateTipoLocalModal: React.FC<Props> = ({ id, onReactivate }) => {
  const modalConfigs = {
    id,
    path: '/tipos-local',
    nameForTitle: 'Tipo de Local',
    onReactivate
  }

  return <ReactivateModal {...modalConfigs} />
}

export default ReactivateTipoLocalModal
